import { isEmpty } from 'ramda';
import React, { createContext, useContext, useState, useMemo, } from 'react';
const ModalErrorContext = createContext({
    hasErrors: false,
    setErrors: () => { },
    errors: undefined,
});
export const ModalErrorProvider = ({ children }) => {
    const [errors, setErrors] = useState();
    const hasErrors = !isEmpty(errors);
    const contextValue = useMemo(() => ({
        hasErrors,
        setErrors,
        errors,
    }), [hasErrors, errors]);
    return (React.createElement(ModalErrorContext.Provider, { value: contextValue }, children));
};
export const useModalErrors = () => useContext(ModalErrorContext);
